import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncRepeatedLoan = loadable(() => import('./RepeatedLoan'), {
  fallback: <Loader />,
});
